export default "__VITE_ASSET__DmT51sUn__"